import { NotificationsProvider } from "@/context/NotificationsContext";
import { InviteProvider } from "@/context/InviteContext";
import { ProviderAvailabilityProvider } from "@/lib/ProviderAvailabilityContext";
import { NewRail } from "@/components/NewRail";
import { BackToNotifications } from "@/components/BackToNotifications";
import { BackToAlerts } from "@/components/BackToAlerts";
import { MatchmakerPrivacyNotice } from "@/components/MatchmakerPrivacyNotice";

export function AppLayout({ children }) {
  return (
    <NotificationsProvider>
      <InviteProvider>
        <ProviderAvailabilityProvider>
          <NewRail>{children}</NewRail>
          <BackToNotifications />
          <BackToAlerts />
          <MatchmakerPrivacyNotice />
        </ProviderAvailabilityProvider>
      </InviteProvider>
    </NotificationsProvider>
  );
}
